module.exports = __webpack_public_path__ + "static/media/sopt22kz.e7da3e98.pdf";